import type { LocationQuery } from 'vue-router'

/**
 * True when a route carries a deep-link device hint — `?serial=` or
 * `?identifier=`. The native apps open the webview that way to land on one
 * specific device: the app then owns navigation, so the portal's own fleet
 * navigation (back link, prev/next arrows) is hidden. A webview opened without
 * a hint browses the whole fleet and keeps its navigation.
 */
export const hasDeviceQueryHint = (query: LocationQuery): boolean => !!(query.serial || query.identifier)
